import Http from '../index'
import Model from '../Model.js'
class ClientFeatures extends Model {
  constructor() {
    super('/client_features/')
    this.knownFlags = []
  }

  async list() {
    this.knownFlags = []
    const resp = await Http.get(`${this.model}features/`)
    for (const flag of resp.data.results) {
      this.knownFlags.push(flag.name)
    }
    return resp
  }

  getFeatureValueForClient(client, feature) {
    return Http.post(`${this.model}get_feature_value_for_client/`, {
      client,
      feature,
    })
  }

  getClientFeatures(id) {
    return Http.get(`${this.model}${id}`)
  }
}

export default new ClientFeatures()
